import React from "react";

import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";


const ParseMarkdown = ({ children }) => {
    return (
        <ReactMarkdown remarkPlugins={[remarkGfm]}>
            {children}
        </ReactMarkdown>
    )
}
export default ParseMarkdown